import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { GetInvoiceResponse } from "./GetInvoice.query";
export class GetInstanceInvoicesParams {
    per_page = 20;
    page: number;
    types: string[];
    search: string;
}

export function getInvoices(instance_id: number, params: GetInstanceInvoicesParams): Promise<AxiosResponse<{invoices: GetInvoiceResponse[], count: number}>> {
    const path = `/instance/${instance_id}/invoices/?page=${params.page}&per_page=${params.per_page||20}&search=${params.search||''}&${params.types.map((type, i) => `type[${i}]=${type}&`).join('')}`;
    return Cirus.get(path);
}